<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1200"
    v-if="isDataLoaded"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <!--      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">-->
      <!--        <form class="row ma-0">-->
      <div class="d-block pa-4 bg-white">
        <!--begin::Body-->
        <v-stepper
          v-model="tab"
          non-linear
          v-if="isStepperReady"
          @change="updateValidationStateOfSteps"
          elevation="0"
        >
          <v-stepper-header class="step-head-main">
            <v-stepper-step
              v-for="(item, i) in categories"
              :key="i"
              class="step-head"
              :class="{ 'bg-secondary': i === tab }"
              editable
              complete
              complete-icon="mdi-check-circle"
              edit-icon="mdi-check"
              error-icon="mdi-alert-circle"
              :step="i"
              :rules="[
                () => {
                  return item.valid;
                },
              ]"
            >
              {{ item.name }}
              <small v-if="!item.valid">Invalid</small>
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="0" class="pt-2">
              <form class="row ma-0">
                <div class="col-12 col-sm-6 h-75px">
                  <v-text-field
                    v-model="formData.name"
                    :label="$t('name')"
                    dense
                    outlined
                    clearable
                    :error-messages="nameErrors"
                    @blur="$v.formData.name.$touch()"
                  />
                </div>

                <div
                  class="col-12 col-sm-6 h-75px"
                  v-if="!$store.getters.isClient"
                >
                  <v-autocomplete
                    v-model="formData.customer_id"
                    :label="$t('customer')"
                    :items="serverData.clients"
                    item-text="text"
                    item-value="index"
                    dense
                    outlined
                    clearable
                    :error-messages="customer_idErrors"
                    @blur="$v.formData.customer_id.$touch()"
                  />
                </div>

                <div class="col-12 col-sm-6 h-75px">
                  <v-text-field
                    v-model="formData.priority"
                    :label="$t('priority')"
                    type="number"
                    dense
                    outlined
                    clearable
                    :error-messages="priorityErrors"
                    @blur="$v.formData.priority.$touch()"
                    @change="() => validateMinValue('priority', 0)"
                  />
                </div>

                <div class="col-12 col-sm-6 h-75px">
                  <v-autocomplete
                    v-model="formData.status"
                    :label="$t('status')"
                    :items="serverData.statuses"
                    item-text="text"
                    item-value="index"
                    dense
                    outlined
                    clearable
                    hide-no-data
                    hide-selected
                    :error-messages="statusErrors"
                    @blur="$v.formData.status.$touch()"
                  />
                </div>

                <div class="col-12 h-75px">
                  <v-text-field
                    v-model="formData.description"
                    :label="$t('description')"
                    dense
                    outlined
                    clearable
                  />
                </div>
              </form>
            </v-stepper-content>

            <v-stepper-content step="1" class="pt-2">
              <div class="mt-4 pa-0 w-100">
                <RuleBuilder
                  :query="query"
                  :options="operands"
                  :userId="userId"
                  ref="ruleBuilder"
                />
              </div>
            </v-stepper-content>

            <v-stepper-content step="2" class="pt-2">
              <div class="mt-4 pa-0 w-100">
                <ActionBuilder
                  :query="formData.attributes"
                  :options="serverData.attributes"
                  :userId="userId"
                  ref="actionBuilder"
                />
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <div
          class="d-flex align-center justify-center modal-action flex-wrap my-4"
        >
          <button
            v-if="tab > 0"
            type="button"
            class="btn btn-secondary mr-7 px-5 py-3 ls1"
            @click="nextStep('prev')"
          >
            Previous
          </button>

          <button
            v-if="tab == 2"
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>

          <button
            v-if="tab < 2"
            type="button"
            class="btn btn-info px-5 py-3 ls1"
            @click="nextStep('next')"
          >
            Continue
          </button>
        </div>
        <!--        <div class="mt-4 pa-0 w-100">-->
        <!--          <RuleBuilder-->
        <!--            :query="query"-->
        <!--            :options="operands"-->
        <!--            :operators="operators"-->
        <!--            :userId="userId"-->
        <!--            ref="ruleBuilder"-->
        <!--          />-->
        <!--        </div>-->
        <!--        <div class="mt-4 pa-0 w-100">-->
        <!--          <ActionBuilder-->
        <!--            :query="formData.attributes"-->
        <!--            :options="serverData.attributes"-->
        <!--            :operators="serverData"-->
        <!--            :userId="userId"-->
        <!--            ref="actionBuilder"-->
        <!--          />-->
        <!--        </div>-->

        <!--begin::Actions-->
        <!--        <div class="my-4 h-75px d-flex flex-grow-1 align-end justify-center">-->
        <!--          <button-->
        <!--            type="reset"-->
        <!--            class="btn btn-light mr-3 px-5 py-3 ls1"-->
        <!--            @click="resetFormData"-->
        <!--          >-->
        <!--            Clear-->
        <!--          </button>-->
        <!--          <button-->
        <!--            type="submit"-->
        <!--            class="btn btn-info px-5 py-3 ls1"-->
        <!--            @click="submitForm"-->
        <!--          >-->
        <!--            {{ submitButtonText }}-->
        <!--          </button>-->
        <!--        </div>-->
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
import RuleBuilder from "@/own/components/orderManagement/promotions/ruleBuilder/RuleBuilder";
import ActionBuilder from "@/own/components/orderManagement/promotions/SKUQuantityBuilder/ActionBuilder";
import Swal from "sweetalert2";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";

export default {
  name: "ActionsDialog",
  props: ["refresher", "pageLoader"],
  mixins: [validationMixin, fieldValueValidation],
  components: { RuleBuilder, ActionBuilder },
  validations() {
    return {
      formData: {
        customer_id: {
          required: requiredIf(function () {
            return !this.isClient;
          }),
        },
        name: { required },
        status: { required },
        priority: { required },
        // payment_mode: { required },
        // shipment_payment_term: { required },
        // shipping_type: { required },
      },
    };
  },
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      customer_id: null,
      name: null,
      priority: null,
      status: null,
      description: null,
      // payment_mode: null,
      // shipment_payment_term: null,
      // shipping_type: null,
      attributes: [],
    },
    query: {
      condition: "and",
      rules: [],
    },

    tab: 0,
    categories: [
      {
        name: "Promotion Details",
        valid: true,
        rules: (el) => {
          // return false;
          return el[`$v`][`formData`].$invalid;
        },
      },
      {
        name: "Promotion types",
        valid: true,
        rules: (el) => {
          return false;
          // try {
          //   return el[`$v`][`consignee`].$invalid;
          // } catch {
          //   return true;
          // }
        },
      },
      {
        name: "Gift",
        valid: true,
        rules: (el) => {
          return false;
          // try {
          //   return el[`$v`][`consignee`].$invalid;
          // } catch {
          //   return true;
          // }
        },
      },
    ],
  }),
  methods: {
    previewStep(n) {
      if (n === 1) this.el = this.steps;
      else this.e1 = n - 1;
    },
    nextStep(type) {
      this.updateValidationStateOfSteps();
      if (type == "next") {
        if (this.tab < 2) {
          this.tab += 1;
        }
      } else {
        if (this.tab > 0) {
          this.tab -= 1;
        }
      }
    },
    updateValidationStateOfSteps() {
      this.$v.$touch();
      this.categories.forEach((cat) => {
        cat.valid = !cat.rules(this);
      });
    },
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
        this.serverData = null;
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    resetFormData() {
      this.formData = {
        customer_id: null,
        name: null,
        priority: null,
        status: null,
        description: null,
        attributes: [],
        // payment_mode: null,
        // shipment_payment_term: null,
        // shipping_type: null,
      };
      this.query = {
        condition: "and",
        rules: [],
      };
    },
    loadDataFromServer() {
      // this.$store.dispatch(GET_DATA);
      this.pageLoader(true);
      if (this.actionType) {
        let sendData = { id: this.$store.getters.getItemForAction.id };
        ApiService.post("/order_management/promotion_rules/edit", sendData)
          .then(({ data }) => {
            if (data.rule.condition)
              this.query = JSON.parse(data.rule.condition);
            delete data.rule.condition;
            this.serverData = data;
            this.formData = data.rule;

            // console.log(" this.query", this.query);
            // console.log(" this.formData", this.formData);
            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      } else {
        ApiService.post("/order_management/promotion_rules/create")
          .then(({ data }) => {
            this.serverData = data;
            this.pageLoader(false);
          })
          .catch(() => {
            this.dialog = false;
            this.pageLoader(false);
          });
      }
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    validateActionBuilderData() {
      let isNotValid = false;
      this.formData.attributes.forEach((attr) => {
        if (
          attr.value === undefined ||
          attr.value === null ||
          attr.value === "" ||
          attr.quantity === undefined ||
          attr.quantity === null ||
          attr.quantity === ""
        ) {
          isNotValid = true;
        }
      });
      return isNotValid;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      // console.log("sendData", this.query);
      if (!this.query.rules.length) {
        Swal.fire({
          title: "Warning",
          text: "Please, add at least one rule!",
          icon: "warning",
        });
        return;
      }

      if (this.$store.getters.getOMSRULESNotValid) {
        // console.log('oms rules not valid', this.$store.getters.getOMSRULESNotValid);
        Swal.fire({
          title: "Warning",
          text: "Please, check there is issue in rule builder!",
          icon: "warning",
        });
        return;
      } //else console.log("noooo");
      // if (!this.formData.attributes.length) {
      //   Swal.fire({
      //     title: "Warning",
      //     text: "Please, add at least one action!",
      //     icon: "warning",
      //   });
      //   return;
      // }
      if (this.validateActionBuilderData()) {
        Swal.fire({
          title: "Warning",
          text: "Please, add at least one attribute!",
          icon: "warning",
        });
        return;
      }

      this.pageLoader(true);
      let sendData = {
        ...this.formData,
      };
      // sendData.customer_id = this.formData.customer_id.map((item) => item.index);
      sendData.condition = JSON.stringify(this.query);
      if (this.actionType) {
        sendData.id = this.$store.getters.getItemForAction.id;
      }
      // console.log("sendData", sendData);
      let actionUrl = "store";
      if (this.actionType) actionUrl = "update";
      ApiService.post(
        `/order_management/promotion_rules/${actionUrl}`,
        sendData
      )
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
  },
  computed: {
    isStepperReady() {
      try {
        return this.$v ? true : false;
      } catch (error) {
        return false;
      }
    },
    // if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    userId: function () {
      return this.$store.getters.isClient
        ? this.$store.getters.currentUser.data.id
        : this.formData.customer_id;
    },
    operands: function () {
      return this.serverData.operands;
    },
    operators: function () {
      return this.serverData.operators;
    },
    customer_idErrors: function () {
      return this.handleFormValidation("customer_id");
    },
    nameErrors: function () {
      return this.handleFormValidation("name");
    },
    priorityErrors: function () {
      return this.handleFormValidation("priority");
    },
    statusErrors: function () {
      return this.handleFormValidation("status");
    },
    // payment_modeErrors: function () {
    //   return this.handleFormValidation("payment_mode");
    // },
    // shipment_payment_termErrors: function () {
    //   return this.handleFormValidation("shipment_payment_term");
    // },
    // shipping_typeErrors: function () {
    //   return this.handleFormValidation("shipping_type");
    // },
    isDataLoaded() {
      return !!this.serverData;
    },
    isClient() {
      return this.$store.getters.isClient;
    },
  },
};
</script>
